/**
 * TODO: Remove in v8.
 */

import * as ko from "knockout";
import "knockout-postbox";
import { isBrowser } from "targetenv";

import { exportInGlobalDbg } from "../util/debug";
import { disposeObject } from "../util/disposable";

import { activateAllPliBindings } from "./pliBindings";
import { activateSubscribeWithChanges } from "./subscribeWithChanges";
import { dirtyFlag } from "./util";


activateSubscribeWithChanges();


/** @deprecated Use 'dirtyFlag' from 'knockout/util'. TODO: Remove in v8. */
(<any>ko).dirtyFlag = dirtyFlag;


/** @deprecated Use 'disposeObject' from 'util/disposable'. TODO: Remove in v8. */
(<any>ko).disposeObject = disposeObject;


if (isBrowser) {
    activateAllPliBindings();

    exportInGlobalDbg("ko", ko);
}

export = ko;



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/knockout/index.ts